// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  slotId: __t.u64().primaryKey().name("slot_id"),
  systemId: __t.string().name("system_id"),
  denKey: __t.string().name("den_key"),
  slot: __t.u8(),
  hp: __t.f64(),
  hpMax: __t.f64().name("hp_max"),
  target: __t.identity(),
  engagedAt: __t.timestamp().name("engaged_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
